/**
 * BulkAnimalsTable - Handsontable table component for bulk animal editing
 * Uses editors, validators, and renderers following the TreatmentGroupsTable pattern
 */
import type { FC, RefObject } from 'react';

import type { MetadataField } from '@/model/Metadata.model';

import Spreadsheet from '@/components/UI/SpreadSheet/Spreadsheet';
import type { SpreadsheetSettings } from '@/components/UI/SpreadSheet/SpreadSheet.model';
import type { HotTableRef } from '@/components/UI/SpreadSheet/HotTable';
import { defaultMetadataToColumnSettingMapper } from '@/support/hot';

interface BulkAnimalsTableProps {
  data: Array<Record<string, unknown>>;
  settings: SpreadsheetSettings;
  innerRef: RefObject<HotTableRef>;
  metadata: Array<MetadataField>;
  setMetadata: (metadata: Array<MetadataField>) => void;
  setInvalid: (invalid: boolean) => void;
  maxRows: number;
}

const BulkAnimalsTable: FC<BulkAnimalsTableProps> = ({
  data,
  settings,
  innerRef,
  metadata,
  setMetadata,
  setInvalid,
  maxRows,
}) => {
  return (
    <Spreadsheet
      className="pl4 pr4"
      testPrefix="bulk-animals"
      data={data}
      innerRef={innerRef}
      settings={settings}
      metadata={metadata}
      setMetadata={setMetadata}
      setInvalid={setInvalid}
      metadataToColumnSettingMapper={defaultMetadataToColumnSettingMapper}
      maxRows={maxRows}
    />
  );
};

export default BulkAnimalsTable;
